import React, {useEffect, useMemo, useState} from 'react';
import PieChart from '../../charts/PieChart'
import BlockChart from "../../BlockChart";
import {useTranslation} from "react-i18next";


const ConsentRequestByLayoutChart = ( {data=[], isSuccess, isFetching: isLoading, refetch} ) => {
  const { t } = useTranslation();
  const formatData = (data) => (
    data.map(el => (
      {
        y: el.count,
        name: el.consent_request_layout_version
      }
    ))
  )
  const formattedData = useMemo(() => (formatData(data)), [data])

  return (
    <BlockChart title={t("cmp.analytics.consentRequestsByLayout")} isLoading={isLoading} isSuccess={isSuccess}>
      <PieChart data={formattedData}/>
    </BlockChart>
  )
}

export default ConsentRequestByLayoutChart
